<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <ArenaPointTypeForm />
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ArenaPointTypeForm from '@/components/settings/arena/point-type/ArenaPointTypeForm'

export default {
  name: 'ArenaPointTypeAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    ArenaPointTypeForm
  }
}
</script>
